export const MAX_NOTIFICATION_EMAILS = 5;
/**
 * Reference: https://support.okta.com/help/s/article/What-Are-the-Character-Limits-for-Certain-Fields-in-the-Okta-Console?language=en_US
 * Identity first name: max 50 characters
 * Identity last name: max 50 characters
 * User email: max 100 characters
 */
export const MAX_NAME_LENGTH = 50;
export const MAX_EMAIL_LENGTH = 100;
